"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseBox = void 0;
var matter_js_1 = require("matter-js");
var BaseBox = /** @class */ (function () {
    function BaseBox(_width, _height, _x, _y, _text) {
        this._width = _width;
        this._height = _height;
        this._x = _x;
        this._y = _y;
        this._text = _text;
        var options = {
            inertia: Infinity,
            frictionAir: 0.05,
            frictionStatic: 0.1,
            friction: 0.8,
            restitution: 0.1,
            render: {
                sprite: {
                    texture: this.renderTexture(),
                    xScale: 1,
                    yScale: 1
                }
            }
        };
        this._matterBody = matter_js_1.Bodies.rectangle(this._x, this._y, this._width, this._height, options);
    }
    BaseBox.prototype.renderTexture = function () {
        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");
        canvas.width = this._width;
        canvas.height = this._height;
        ctx.fillStyle = "#000";
        this.roundRect(ctx, 0, 0, this._width, this._height, 5);
        ctx.fillStyle = "#fff";
        ctx.font = "24px BalooBhai-Regular, sans-serif";
        ctx.textAlign = "center";
        ctx.fillText(this._text, this._width / 2, (this._height / 2 + 10));
        return canvas.toDataURL("image/png");
    };
    // Stackoverflow: Grumdrig
    // Credit: https://stackoverflow.com/a/7838871
    BaseBox.prototype.roundRect = function (ctx, x, y, w, h, r) {
        if (w < 2 * r)
            r = w / 2;
        if (h < 2 * r)
            r = h / 2;
        ctx.beginPath();
        ctx.moveTo(x + r, y);
        ctx.arcTo(x + w, y, x + w, y + h, r);
        ctx.arcTo(x + w, y + h, x, y + h, r);
        ctx.arcTo(x, y + h, x, y, r);
        ctx.arcTo(x, y, x + w, y, r);
        ctx.fill();
        ctx.closePath();
    };
    Object.defineProperty(BaseBox.prototype, "body", {
        get: function () { return this._matterBody; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseBox.prototype, "x", {
        get: function () { return this.body.position.x; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseBox.prototype, "y", {
        get: function () { return this.body.position.y; },
        enumerable: false,
        configurable: true
    });
    BaseBox.prototype.text = function () { return this._text; };
    return BaseBox;
}());
exports.BaseBox = BaseBox;
